import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { getConsolidadoPeriodo } from "../../../services/services";
import LoadingChart from "../../Home/components/loadingChart";
import formatDateType from "../../../utils/formatDateType";
import { useDate } from "../../../hooks/useDate";

export default function TotalizadorConcentradoStaker() {
  const SECUENCIA = 1;

  // Objeto por default de los states
  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  const [valorSemana, setValorSemana] = useState(defaultObject);
  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();
  //Loading
  const [isLoading, setIsLoading] = useState(true);

  // Efecto que se ejecturara cada vez que cambien las props
  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const { data } = await getConsolidadoPeriodo({
        secuencia: SECUENCIA,
        periodo: "S",
      });
      
      setDateHook(data, "Totalizador Concentrado Stacker: Turno");
      populateValorSemana(data);
      setIsLoading(false);
    }

    fetchData();
  }, []);

  function populateValorSemana(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Concentrado Stacker: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorSemana);
      arrFechas.push(element.fecha);
    });

    setValorSemana({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      {isLoading ? (
        <LoadingChart />
      ) : (
        <Card>
          <Card.Content>
            <Chart
              title="Concentrado Stacker"
              subtitle={"Periodo " + fullDate()}
              zoom="x"
            >
              <Chart.Column
                name="Concentrado Stacker: Turno"
                data={valorSemana.value}
              />
              <Chart.XAxis
                categories={formatDateType(valorSemana.fecha, "S")}
              />
              <Chart.YAxis
                labelSuffix=" t"
                title="Masa de Concentrado, t"
                lineWidth={2}
                lineColor="white"
              />

              <Chart.Tooltip valueSuffix=" t" />
            </Chart>
          </Card.Content>
        </Card>
      )}
    </>
  );
}
